/**
 * Paean Brand Assets — canonical, non-Ink-coupled palette and glyphs.
 *
 * For Ink-rendered surfaces, prefer `./ink-theme.ts` which extends these
 * tokens with layout helpers and the Paean Family sigil.
 */

// Brand Colors — canonical values mirrored by COLORS in ink-theme.ts
export const BRAND_COLORS = {
  primary: '#0077FF',      // Paean Blue
  primaryLight: '#00F0FF', // Paean Highlight Cyan
  primaryDark: '#007799',  // Paean Deep Teal
  secondary: '#8b5cf6',    // Violet Accent
  success: '#10b981',      // Emerald
  warning: '#f59e0b',      // Amber
  error: '#ef4444',        // Red
  muted: '#71717a',        // Gray
  bg: '#000000',           // Page background
  card: '#121212',         // Surface
};

/**
 * Paean Family — sibling product marks. Render the trio in the muted
 * accent to acknowledge family membership without competing visually.
 *   ⌬ Zero · ∩ Paean · ∞ Articulate
 */
export const PAEAN_FAMILY = {
  zero: '⌬',
  paean: '∩',
  articulate: '∞',
  sigil: '⌬ · ∩ · ∞',
  tag: 'Paean Family',
} as const;

// Paean Brand Symbols for CLI
// USE ∩（U+2229）for Paean ASCII Logo
export const PAEAN_SYMBOLS = {
  arch: '∩',           // Primary brand logo symbol
  archFilled: '⌓',     // Alternative arch
  dot: '◉',            // Status dot — active
  dotEmpty: '○',       // Status dot — idle
  diamond: '◆',        // Diamond accent / pin
  bullet: '•',         // Bullet point
  sparklet: '✦',       // Highlight / streaming
};